// 3rd party
import { flowResult } from 'mobx';

// Bernie
import { ClientLogger } from 'bernie-client';
import { Controller, FetchOptions, Result } from 'bernie-core';
import { AppFetchContext } from 'bernie-core/dist/controller/fetch-options';

// Stores
import { AccountDataStateStore, PzStore, UiStore, UserAuthStore, UserStore } from 'stores';
import { AccountDataState } from 'stores/account-data-state-store';

// Utils
import AffiliateHubLogger from '../util/affiliate-hub-logger';

// tslint:disable-next-line
const wrapWithAccountDataController = (classRef: { new (): Controller }): { new (): Controller } => {
  class WithAccountDataController extends classRef {
    public async fetch(options: FetchOptions): Promise<Result> {
      if (options.isServer) {
        return Promise.resolve({});
      }
      const logger = new AffiliateHubLogger(
        ClientLogger.getLoggerWithIdentifier(`controller.${WithAccountDataController.name}.${classRef.name}`),
      );

      const { request, stores } = options;

      const accountDataStateStore = stores.get<AccountDataStateStore>('accountDataStateStore');
      const pzStore = stores?.get<PzStore>('pzStore');
      const uiStore = stores?.get<UiStore>('uiStore');
      const userStore = stores?.get<UserStore>('user');
      const userAuthStore = stores?.get<UserAuthStore>('userAuth');

      // Set active program for join program / product page
      if (request.query.programName) {
        const programId = request.query.programName;
        userStore.setActiveProgramId(programId);
      }

      // re-initialize only when required
      if (accountDataStateStore.status !== AccountDataState.INITIALIZED) {
        accountDataStateStore.markAsPending();
        try {
          // Check that logged in partner is authed...?
          await userAuthStore.checkAuth();

          // Get logged in partner info
          await userAuthStore.fetchUserDetails();
          const userDetails = userAuthStore.userDetails.body;

          // Check Partnerize status
          const partnerId = userDetails.partnerId || userStore.pzPartnerId;
          if (partnerId) {
            await pzStore.fetchPzUser(partnerId);
          }

          // Fetch partner programs
          const token = await userAuthStore.getAccessToken();
          const email = userAuthStore.currentUser.email;

          const showHidden = request.query.showHidden === 'true';
          await flowResult(userStore.fetchPrograms(email, token, showHidden));

          uiStore.setPosa(localStorage?.getItem('posa') ?? userDetails.country);

          accountDataStateStore.markAsInitialized();
        } catch (e) {
          // 401 means user is not authenticated, this means data has been initialized - user is unauthorized.
          if (e?.errorCode === 401) {
            accountDataStateStore.markAsInitialized();
          } else {
            logger.error('FAILED_TO_FETCH_ACCOUNT_DATA', e);
            accountDataStateStore.markAsFailed();
          }
        }
      }

      const appFetchContext: AppFetchContext = {
        data: {},
        logger: {
          logEvent: () => undefined,
        },
      };

      return super.fetch(options, appFetchContext);
    }
  }

  return WithAccountDataController;
};

export default wrapWithAccountDataController;
